export class FormPropertyModel {
    formStatus = false;
    formAttribute: any[];
}
